import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { Box } from '@mui/material';
import { useArrowScrollerStyles } from './arrowScroller.styles';
import useArrowScroller from './hooks/useArrowScroller';
import { ArrowScrollerProps, ScrollDirection } from './types/arrowScroller.types';

const ArrowScroller = ({ children, containerRef, scrollAmount }: ArrowScrollerProps) => {
  const { classes, cx } = useArrowScrollerStyles();
  const { canScrollLeft, canScrollRight, scroll } = useArrowScroller({
    containerRef,
    scrollAmount,
  });

  return (
    <Box
      sx={{
        display: 'flex',
      }}
    >
      <Box
        className={cx({
          [classes.shadowLeftContainer]: true,
          [classes.stickyContainer]: true,
          [classes.hideContainer]: !canScrollLeft,
        })}
        sx={{
          alignContent: 'center',
        }}
      >
        <ArrowLeftIcon onClick={() => scroll(ScrollDirection.LEFT)} className={classes.arrow} />
      </Box>
      {children}
      <Box
        className={cx({
          [classes.shadowRightContainer]: true,
          [classes.stickyContainer]: true,
          [classes.hideContainer]: !canScrollRight,
        })}
        sx={{
          alignContent: 'center',
        }}
      >
        <ArrowRightIcon onClick={() => scroll(ScrollDirection.RIGHT)} className={classes.arrow} />
      </Box>
    </Box>
  );
};

export default ArrowScroller;
